// GENERATED by art/gen/apply_collectibles.py: the collectibles that have sticker art (WI-13e).
// Ids missing here show their emoji stand-in.
export const COLLECTIBLE_ART: Readonly<Record<string, string>> = {
  "bigcity:bento": "/collectibles/bigcity/bento.webp",
  "bigcity:boar": "/collectibles/bigcity/boar.webp",
  "bigcity:crane": "/collectibles/bigcity/crane.webp",
  "bigcity:fireworks": "/collectibles/bigcity/fireworks.webp",
  "bigcity:skewer": "/collectibles/bigcity/skewer.webp",
  "bigcity:taxi": "/collectibles/bigcity/taxi.webp",
  "bigcity:tower": "/collectibles/bigcity/tower.webp",
  "bigcity:train": "/collectibles/bigcity/train.webp",
  "castletown:blossom": "/collectibles/castletown/blossom.webp",
  "castletown:bridge": "/collectibles/castletown/bridge.webp",
  "castletown:castle": "/collectibles/castletown/castle.webp",
  "castletown:drum": "/collectibles/castletown/drum.webp",
  "castletown:fan": "/collectibles/castletown/fan.webp",
  "castletown:koi": "/collectibles/castletown/koi.webp",
  "castletown:samurai": "/collectibles/castletown/samurai.webp",
  "castletown:sword": "/collectibles/castletown/sword.webp",
  "fuji:boat": "/collectibles/fuji/boat.webp",
  "fuji:egg": "/collectibles/fuji/egg.webp",
  "fuji:flower": "/collectibles/fuji/flower.webp",
  "fuji:fuji": "/collectibles/fuji/fuji.webp",
  "fuji:lake": "/collectibles/fuji/lake.webp",
  "fuji:onsen": "/collectibles/fuji/onsen.webp",
  "fuji:ropeway": "/collectibles/fuji/ropeway.webp",
  "fuji:train": "/collectibles/fuji/train.webp",
  "fukuoka:bird": "/collectibles/fukuoka/bird.webp",
  "fukuoka:dome": "/collectibles/fukuoka/dome.webp",
  "fukuoka:ferry": "/collectibles/fukuoka/ferry.webp",
  "fukuoka:mentai": "/collectibles/fukuoka/mentai.webp",
  "fukuoka:ramen": "/collectibles/fukuoka/ramen.webp",
  "fukuoka:stall": "/collectibles/fukuoka/stall.webp",
  "fukuoka:tower": "/collectibles/fukuoka/tower.webp",
  "fukuoka:ume": "/collectibles/fukuoka/ume.webp",
  "hangang:bike": "/collectibles/hangang/bike.webp",
  "hangang:bungeo": "/collectibles/hangang/bungeo.webp",
  "hangang:cable": "/collectibles/hangang/cable.webp",
  "hangang:chicken": "/collectibles/hangang/chicken.webp",
  "hangang:deer": "/collectibles/hangang/deer.webp",
  "hangang:ferry": "/collectibles/hangang/ferry.webp",
  "hangang:ramyeon": "/collectibles/hangang/ramyeon.webp",
  "hangang:tower": "/collectibles/hangang/tower.webp",
  "kamakura:bell": "/collectibles/kamakura/bell.webp",
  "kamakura:buddha": "/collectibles/kamakura/buddha.webp",
  "kamakura:hawk": "/collectibles/kamakura/hawk.webp",
  "kamakura:hydrangea": "/collectibles/kamakura/hydrangea.webp",
  "kamakura:shell": "/collectibles/kamakura/shell.webp",
  "kamakura:shrimp": "/collectibles/kamakura/shrimp.webp",
  "kamakura:train": "/collectibles/kamakura/train.webp",
  "kamakura:wave": "/collectibles/kamakura/wave.webp",
  "kyoto:bamboo": "/collectibles/kyoto/bamboo.webp",
  "kyoto:dango": "/collectibles/kyoto/dango.webp",
  "kyoto:fox": "/collectibles/kyoto/fox.webp",
  "kyoto:geisha": "/collectibles/kyoto/geisha.webp",
  "kyoto:maple": "/collectibles/kyoto/maple.webp",
  "kyoto:tea": "/collectibles/kyoto/tea.webp",
  "kyoto:temple": "/collectibles/kyoto/temple.webp",
  "kyoto:torii": "/collectibles/kyoto/torii.webp",
  "miyajima:boat": "/collectibles/miyajima/boat.webp",
  "miyajima:deer": "/collectibles/miyajima/deer.webp",
  "miyajima:gate": "/collectibles/miyajima/gate.webp",
  "miyajima:maple": "/collectibles/miyajima/maple.webp",
  "miyajima:monkey": "/collectibles/miyajima/monkey.webp",
  "miyajima:oyster": "/collectibles/miyajima/oyster.webp",
  "miyajima:spoon": "/collectibles/miyajima/spoon.webp",
  "miyajima:wave": "/collectibles/miyajima/wave.webp",
  "nara:bell": "/collectibles/nara/bell.webp",
  "nara:buddha": "/collectibles/nara/buddha.webp",
  "nara:cracker": "/collectibles/nara/cracker.webp",
  "nara:deer": "/collectibles/nara/deer.webp",
  "nara:lantern": "/collectibles/nara/lantern.webp",
  "nara:mochi": "/collectibles/nara/mochi.webp",
  "nara:pagoda": "/collectibles/nara/pagoda.webp",
  "nara:tree": "/collectibles/nara/tree.webp",
  "niseko:fox": "/collectibles/niseko/fox.webp",
  "niseko:gondola": "/collectibles/niseko/gondola.webp",
  "niseko:mountain": "/collectibles/niseko/mountain.webp",
  "niseko:onsen": "/collectibles/niseko/onsen.webp",
  "niseko:skis": "/collectibles/niseko/skis.webp",
  "niseko:snowboard": "/collectibles/niseko/snowboard.webp",
  "niseko:snowman": "/collectibles/niseko/snowman.webp",
  "niseko:yeti": "/collectibles/niseko/yeti.webp",
  "okinawa:fish": "/collectibles/okinawa/fish.webp",
  "okinawa:hibiscus": "/collectibles/okinawa/hibiscus.webp",
  "okinawa:palm": "/collectibles/okinawa/palm.webp",
  "okinawa:pineapple": "/collectibles/okinawa/pineapple.webp",
  "okinawa:shell": "/collectibles/okinawa/shell.webp",
  "okinawa:shisa": "/collectibles/okinawa/shisa.webp",
  "okinawa:turtle": "/collectibles/okinawa/turtle.webp",
  "okinawa:whale": "/collectibles/okinawa/whale.webp",
  "osaka:castle": "/collectibles/osaka/castle.webp",
  "osaka:crab": "/collectibles/osaka/crab.webp",
  "osaka:fugu": "/collectibles/osaka/fugu.webp",
  "osaka:lights": "/collectibles/osaka/lights.webp",
  "osaka:okonomi": "/collectibles/osaka/okonomi.webp",
  "osaka:runner": "/collectibles/osaka/runner.webp",
  "osaka:takoyaki": "/collectibles/osaka/takoyaki.webp",
  "osaka:train": "/collectibles/osaka/train.webp",
  "otaru:boat": "/collectibles/otaru/boat.webp",
  "otaru:crab": "/collectibles/otaru/crab.webp",
  "otaru:float": "/collectibles/otaru/float.webp",
  "otaru:gull": "/collectibles/otaru/gull.webp",
  "otaru:lantern": "/collectibles/otaru/lantern.webp",
  "otaru:music": "/collectibles/otaru/music.webp",
  "otaru:steam": "/collectibles/otaru/steam.webp",
  "otaru:sushi": "/collectibles/otaru/sushi.webp",
  "sapporo:clock": "/collectibles/sapporo/clock.webp",
  "sapporo:corn": "/collectibles/sapporo/corn.webp",
  "sapporo:crow": "/collectibles/sapporo/crow.webp",
  "sapporo:plough": "/collectibles/sapporo/plough.webp",
  "sapporo:ramen": "/collectibles/sapporo/ramen.webp",
  "sapporo:sculpture": "/collectibles/sapporo/sculpture.webp",
  "sapporo:streetcar": "/collectibles/sapporo/streetcar.webp",
  "sapporo:tv": "/collectibles/sapporo/tv.webp",
  "seoul:bingsu": "/collectibles/seoul/bingsu.webp",
  "seoul:drum": "/collectibles/seoul/drum.webp",
  "seoul:gat": "/collectibles/seoul/gat.webp",
  "seoul:gate": "/collectibles/seoul/gate.webp",
  "seoul:haechi": "/collectibles/seoul/haechi.webp",
  "seoul:magpie": "/collectibles/seoul/magpie.webp",
  "seoul:noodles": "/collectibles/seoul/noodles.webp",
  "seoul:pancake": "/collectibles/seoul/pancake.webp",
  "shirakawago:bridge": "/collectibles/shirakawago/bridge.webp",
  "shirakawago:house": "/collectibles/shirakawago/house.webp",
  "shirakawago:lights": "/collectibles/shirakawago/lights.webp",
  "shirakawago:owl": "/collectibles/shirakawago/owl.webp",
  "shirakawago:rice": "/collectibles/shirakawago/rice.webp",
  "shirakawago:sled": "/collectibles/shirakawago/sled.webp",
  "shirakawago:snow": "/collectibles/shirakawago/snow.webp",
  "shirakawago:tree": "/collectibles/shirakawago/tree.webp",
  "tokyo:cat": "/collectibles/tokyo/cat.webp",
  "tokyo:crossing": "/collectibles/tokyo/crossing.webp",
  "tokyo:games": "/collectibles/tokyo/games.webp",
  "tokyo:lantern": "/collectibles/tokyo/lantern.webp",
  "tokyo:robot": "/collectibles/tokyo/robot.webp",
  "tokyo:sushi": "/collectibles/tokyo/sushi.webp",
  "tokyo:tower": "/collectibles/tokyo/tower.webp",
  "tokyo:train": "/collectibles/tokyo/train.webp",
  "traveller:camera": "/collectibles/traveller/camera.webp",
  "traveller:compass": "/collectibles/traveller/compass.webp",
  "traveller:globe": "/collectibles/traveller/globe.webp",
  "traveller:map": "/collectibles/traveller/map.webp",
  "traveller:plane": "/collectibles/traveller/plane.webp",
  "traveller:postcard": "/collectibles/traveller/postcard.webp",
  "traveller:suitcase": "/collectibles/traveller/suitcase.webp",
  "traveller:ticket": "/collectibles/traveller/ticket.webp",
  "village:firefly": "/collectibles/village/firefly.webp",
  "village:frog": "/collectibles/village/frog.webp",
  "village:mush": "/collectibles/village/mush.webp",
  "village:persimmon": "/collectibles/village/persimmon.webp",
  "village:rice": "/collectibles/village/rice.webp",
  "village:scarecrow": "/collectibles/village/scarecrow.webp",
  "village:tanuki": "/collectibles/village/tanuki.webp",
  "village:well": "/collectibles/village/well.webp",
}
